import { create } from 'zustand';

interface PermissionDeniedState {
  open: boolean;
  /** Human-readable action label, e.g. "delete photos". */
  action: string | null;
  show: (action: string) => void;
  close: () => void;
}

/**
 * Drives the global PermissionDeniedModal. Any gated action a manager lacks
 * permission for can surface a clear "you don't have access" modal by calling
 * `denyAction(label)` — no prop threading for the modal itself.
 */
export const usePermissionDeniedStore = create<PermissionDeniedState>((set) => ({
  open: false,
  action: null,
  show: (action) => set({ open: true, action }),
  // Keep `action` so the text stays put through the modal's exit animation.
  close: () => set({ open: false }),
}));

/** Imperative helper for non-hook call sites (event handlers, catch blocks). */
export function denyAction(action: string): void {
  usePermissionDeniedStore.getState().show(action);
}

/** True for a server "forbidden" (403) response — i.e. a permission failure. */
export function isPermissionError(err: unknown): boolean {
  const e = err as { response?: { status?: number } } | null;
  return e?.response?.status === 403;
}
